export const environment = {
    production: false,
    apiUrl:'https://flexseat-api.test.it-for-it.devtest.gf.aws.scania.com/api'
};
